type UnknownObject = Record<string, unknown>;

const isObject = (value: unknown): value is UnknownObject =>
  typeof value === "object" && value !== null;

export const formatApiError = (error: unknown): string => {
  if (error instanceof Error) {
    if (error.message === "Network Error") {
      return "Network error. Check your connection, Cognito/AdminQueries availability, or whether this browser session is still signed in.";
    }
    return error.message;
  }

  if (isObject(error)) {
    const withMessage = error as { message?: unknown };
    if (typeof withMessage.message === "string" && withMessage.message.trim()) {
      return withMessage.message;
    }

    const withErrors = error as { errors?: unknown };
    if (Array.isArray(withErrors.errors) && withErrors.errors.length > 0) {
      const messages = withErrors.errors
        .map((item) => (isObject(item) && typeof item.message === "string" ? item.message.trim() : ""))
        .filter(Boolean);
      if (messages.length > 0) {
        return Array.from(new Set(messages)).slice(0, 3).join(" | ");
      }
    }

    const withResponse = error as { response?: unknown };
    if (isObject(withResponse.response)) {
      const response = withResponse.response as { data?: unknown; status?: unknown };
      if (typeof response.status === "number") {
        if (response.status === 401 || response.status === 403) {
          return "Not authorized. Your user role does not have access.";
        }
        if (response.status >= 500) {
          return `Server error ${response.status}. The backend function or resolver failed.`;
        }
      }
      if (typeof response.data === "string" && response.data.trim()) {
        return response.data;
      }
      if (isObject(response.data)) {
        const data = response.data as { message?: unknown; name?: unknown; statusCode?: unknown };
        if (typeof data.message === "string" && data.message.trim()) {
          return data.message;
        }
        if (typeof data.name === "string" && data.name.trim()) {
          return data.name;
        }
      }
    }
  }

  return "Unexpected API error.";
};
